module.exports = __webpack_public_path__ + "static/assets/381b8964610deccaeba07743f16e8953.png";